module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	fox.registerWidget('SitePage_Post', {
		activate: function (params) {
			this.callParent('activate', arguments);
			this.postviewer = this.rwom1('.PostViewer');
			this.handleEvent(fox.Navigator, 'modified_1', function () {
				if (fox.Navigator.get(1)) {
					return this.postviewer.fetch(fox.Navigator.get(1));
				}
			}, this);
			return this.postviewer.fetch(params.id);
			
		},
		

	}, 'Site_Page');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/post.js
// module id = 927
// module chunks = 4